export const meta_standard = 'Meta Information Goes Here'
export const meta_404 = 'Womp womp. Looks like this link is broken.'



// WEBPACK FOOTER //
// ./src/store/constants/meta_info.js